import { lazy } from 'react'
import { Route, Switch } from '@hfs/react-router'
import { getRoute } from '@hfs/website/utils/getRoute'

export const SitemapRoutes = () => (
  <Switch>
    <Route
      component={lazy(async () => {
        const { Sitemap } = await import(
          /* webpackPrefetch: true, webpackChunkName: "News" */ '@hfs/website/react/pages/public/Sitemap'
        )

        return {
          default: Sitemap,
        }
      })}
      exact
      path={getRoute('/sitemap')}
    />
  </Switch>
)
